<template>
  <div class="ma-3">
    <div class="title mb-3">
      Sessions <v-icon>mdi-chevron-right</v-icon> Teams management
      <v-icon>mdi-chevron-right</v-icon> {{ isNew ? "New" : team.name }}
    </div>

    <v-form
      ref="form"
      v-model="formValid"
      layout="column"
      layout-align="center center"
      @submit.prevent="save"
    >
      <div>
        <div class="title font-weight-light mb-3">
          Team information
        </div>
        <v-text-field
          v-model="team.name"
          outline
          label="Name"
          class="field-width"
          :rules="[v => !!v || 'This field is required']"
        />
        <v-text-field
          v-model="team.email"
          outline
          label="Email address"
          class="field-width"
        />
        <v-select
          v-if="Auth.user.application == Consts.APPLICATION.ALL"
          v-model="team.application"
          v-focus
          label="Application"
          :items="apps"
          class="field-width"
          outline
          :rules="[ v => !!v || 'This field is required' ]"
          @change="onApplicationChange"
        />
        <v-select
          v-if="team.application != Consts.APPLICATION.BEESECURE"
          v-model="team.center_id"
          v-focus
          label="Center"
          :items="centers"
          item-text="name"
          item-value="id"
          class="field-width"
          outline
          :rules="[v => !!v || team.application == Consts.APPLICATION.BEESECURE || 'This field is required']"
        />
        <v-text-field
          v-model="team.sync_id"
          outline
          label="Sync code"
          class="field-width"
        />
        <v-checkbox
          v-if="team.sync_id === 'sport'"
          v-model="team.include_divers"
          label="Include &quot;divers&quot;"
          :true-value="1"
          :false-value="0"
        />
        <v-autocomplete
          v-model="team.intern_evaluation_form_id"
          label="Evaluation form for the expert about its interns"
          :items="forms"
          item-text="name"
          item-value="id"
          class="field-width"
          outline
          clearable
          :open-on-clear="false"
          @click:clear="clearFormField('intern_evaluation_form_id')"
        />

        <div class="title font-weight-light mb-3">
          Default max capacities
        </div>
        <v-text-field
          v-model="team.max_capacity_morning"
          type="number"
          outline
          label="Morning"
          class="field-width"
          :rules="[
            v => !v || /^[0-9]+$/.test(v) || 'This field must be a number',
            v => !v || v >= 0 || 'This field is required'
          ]"
        />
        <v-text-field
          v-model="team.max_capacity_afternoon"
          type="number"
          outline
          label="Afternoon"
          class="field-width"
          :rules="[
            v => !v || /^[0-9]+$/.test(v) || 'This field must be a number',
            v => !v || v >= 0 || 'This field is required'
          ]"
        />
        <v-text-field
          v-model="team.max_capacity_evening"
          type="number"
          outline
          label="Evening"
          class="field-width"
          :rules="[
            v => !v || /^[0-9]+$/.test(v) || 'This field must be a number',
            v => !v || v >= 0 || 'This field is required'
          ]"
        />
      </div>

      <v-btn
        depressed
        color="primary"
        @click="save"
      >
        Save
      </v-btn>
      <router-link
        :to="{ name: 'admin-sessions-teams-index' }"
        class="grey--text"
      >
        Cancel
      </router-link>
    </v-form>
  </div>
</template>

<script>
import Params from "@/api/params"
import GlobalMixin from "@/mixins/global"
import Auth from "@/plugins/auth"
import Consts from "@/consts"

export default {
  mixins: [GlobalMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from.name;
    });
  },
  props: {
    value: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data() {
    return {
      team: {
        name: null,
        email: null,
        application: Auth.user.application,
        sync_id: null,
        include_divers: null,
        center_id: null,
        intern_evaluation_form_id: null,
        max_capacity_morning: 0,
        max_capacity_afternoon: 0,
        max_capacity_evening: 0,
      },
      prevRoute: null,
      formValid: false,
      centers: [],
      forms: [],
      Auth,
      Consts
    };
  },
  computed: {
    isNew() {
      return this.$route.params.id === "new";
    }
  },
  async mounted() {
    if (!this.isNew) {
      await this.fetch();
    }
    Params.getList("centers", {is_enabled: 1, current_id: this.isNew ? null : this.team.center_id, sortBy: "name"}).then(res => {
      this.centers = res.data
    })
    Params.getList('forms', {sortBy: 'name'}).then(res => {
        this.forms = res.data;
    })
  },
  methods: {
    clearFormField(f) {
      this.$nextTick(() => {
        this.team[f] = null
      })
    },
    async fetch() {
      const teamResp = await Params.get("teams", this.$route.params.id)
      this.team = teamResp.data
    },
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (this.isNew) {
        Params.create("teams", this.team).then(() => {
          this.$router.push({
            name:
              this.prevRoute !== null
                ? this.prevRoute
                : "admin-sessions-teams-index"
          });
          this.$snotify.success(
            `Team "${this.team.name}" has been created`
          );
        });
      } else {
        Params.update("teams", this.team.id, this.team).then(() => {
          this.$router.push({
            name:
              this.prevRoute !== null
                ? this.prevRoute
                : "admin-sessions-teams-index"
          });
          this.$snotify.success(
            `Team "${this.team.name}" has been updated`
          );
        });
      }
    },
    onApplicationChange() {
      this.team.center_id = null
    }
  }
};
</script>
